const destinationDetails = {
    overview: 'Overzicht',
    pointsOfInterest: 'Bezienswaardigheden',
    activities: 'Activiteiten',
    gallery: 'Galerij',
    map: 'Kaart',
    bookYourExperience: 'Boek Je Ervaring',
    discoverOurTrips: 'Ontdek onze reizen die omvatten',
    wantToVisit: 'Wil je deze bestemming bezoeken?',
    contactUsForTrip: 'Neem contact met ons op om je gepersonaliseerde reis te organiseren.',
    requestQuote: 'Vraag Offerte Aan',
    breadcrumbDestinations: 'Bestemmingen',
    breadcrumbActivities: 'Activiteiten',
    cornoGrande: 'Corno Grande - De hoogste top',
    campoImperatore: 'Campo Imperatore - Het "Kleine Tibet"',
    rifugioDuca: 'Duca degli Abruzzi Refuge',
    sentieroCentenario: 'Eeuwfeestpad',
    vistaPanoramica: 'Panoramisch uitzicht over heel Abruzzo',
    // Destination descriptions
    granSassoDescription: 'Gran Sasso d\'Italia is de hoogste top van de continentale Apennijnen, met een hoogte van 2.912 meter. Deze majestueuze berg biedt adembenemende landschappen, wandelpaden voor alle niveaus en de mogelijkheid om wintersporten te beoefenen tijdens het koude seizoen.',
    granSassoSubtitle: 'De Reus van de Apennijnen',
    roccaCalascioDescription: 'In het hart van het Nationaal Park Gran Sasso en Monti della Laga is Rocca Calascio een van de meest suggestieve dorpen van Abruzzo. Gelegen op meer dan 1.400 meter hoogte, biedt dit kleine juweel adembenemende uitzichten en een tijdloze sfeer. Het dorp, nu half verlaten, behoudt een unieke charme tussen stenen ruïnes, stilte en oneindige panorama\'s over de Abruzzo bergen. Een perfecte plek voor wie op zoek is naar authenticiteit, schoonheid en een diepe verbinding met natuur en geschiedenis.',
    roccaCalascioSubtitle: 'Het Dorp in de Wolken',
    collaltoSabinoDescription: 'Gelegen op een heuvel tussen de bossen en heuvels van Sabina, is Collalto Sabino een van de mooiste dorpen van Italië, rijk aan middeleeuwse charme en adembenemende panorama\'s. Stenen muren, torens, smalle steegjes en een perfect bewaard kasteel maken het een onmisbare stop voor wie op zoek is naar authenticiteit, geschiedenis en schoonheid buiten de meest toeristische routes. Een plek waar de tijd lijkt stil te staan, ideaal voor een ontspannende wandeling en om ondergedompeld te worden in de magie van een intiem en verborgen Italië.',
    collaltoSabinoSubtitle: 'Het Middeleeuwse Dorp van Sabina',
    santoStefanoDiSessanioDescription: 'In het hart van het Gran Sasso Nationaal Park is Santo Stefano di Sessanio een van de meest fascinerende dorpen van Abruzzo. Een klein middeleeuws juweel in wit kalksteen, perfect geïntegreerd in het omringende berglandschap. Met grote zorg gerestaureerd, heeft het dorp zijn oude ziel intact gehouden en is het een symbool geworden van langzaam en duurzaam toerisme. Een plek waar elke stap een verhaal vertelt en elke hoek uitnodigt tot contemplatie.',
    santoStefanoDiSessanioSubtitle: 'Het Middeleeuwse Juweel van Gran Sasso',
    trabocchiCoastDescription: 'De Costa dei Trabocchi is een van de meest suggestieve kuststroken van de Adriatische Zee, gekenmerkt door oude houten visserijconstructies die zich uitstrekken over de zee als slapende reuzen. Deze kust, die zich uitstrekt over ongeveer 70 kilometer tussen Ortona en Vasto, biedt een uniek landschap waar geschiedenis, traditie en natuur perfect samensmelten. De trabocchi, oude vismachines uit de 18e eeuw, zijn vandaag symbolen van een maritieme kunst die de tijd trotseert, omringd door ongerepte stranden, verborgen baaien en adembenemende uitzichten op de kristalheldere zee.',
    trabocchiCoastSubtitle: 'De Betoverde Kust van de Trabocchi',
    // Rocca Calascio points of interest
    castelloRoccaCalascio: 'Rocca Calascio Kasteel - Een van de hoogste kastelen van Italië',
    chiesaSantaMaria: 'Kerk van Santa Maria della Pietà - 17e-eeuws achthoekig juweel',
    vistaPanoramica360: '360 graden panoramisch uitzicht',
    borgoMedievale: 'Half verlaten middeleeuws dorp',
    sentieriPanoramici: 'Panoramische paden in de bergen',
    // Alba Fucens points of interest
    anfiteatroRomano: 'Romeins Amfitheater - Een van de best bewaarde van Midden-Italië',
    chiesaSanPietro: 'Kerk van San Pietro - Gebouwd op de resten van een heidense tempel',
    vestigiaRomane: 'Romeinse overblijfselen en geplaveide straten',
    panoramiMonteVelino: 'Uitzichten op Monte Velino',
    sitoArcheologico: 'Archeologische site van nationaal belang',
    // Activities
    mountainExcursions: 'Bergwandelingen',
    rockClimbing: 'Rotsklimmen',
    wildlifeObservation: 'Wildlife observatie',
    alpineCrossCountrySkiing: 'Alpineskiën en langlaufen',
    naturePhotography: 'Natuurfotografie',
    // Rocca Calascio specific activities
    panoramicWalk: 'Panoramische wandeling in het middeleeuwse dorp',
    castleVisit: 'Bezoek aan het kasteel en de kerk',
    landscapePhotography: 'Landschapsfotografie',
    culturalImmersion: 'Ondergedompeld worden in lokale geschiedenis en cultuur',
    // Alba Fucens specific activities
    archaeologicalWalk: 'Archeologische wandeling tussen de ruïnes',
    amphitheaterVisit: 'Bezoek aan het Romeinse amfitheater',
    churchExploration: 'Verkenning van de Kerk van San Pietro',
    archaeologicalPhotography: 'Archeologische en landschapsfotografie',
    romanHistoryImmersion: 'Ondergedompeld worden in de Romeinse geschiedenis',
    // Pescasseroli specific activities
    historicCenterWalk: 'Ontspannende wandeling in het historische centrum',
    nationalParkExploration: 'Verkenning van het Nationaal Park',
    localProductsDiscovery: 'Ontdekking van typische lokale producten',
    abruzzoCultureImmersion: 'Ondergedompeld worden in de Abruzzo cultuur',
    // Rocca di Mezzo specific activities
    villageCenterWalk: 'Wandeling in het dorpscentrum',
    historicStreetsExploration: 'Verkenning van historische straten en pleinen',
    plateauTrailsWalk: 'Wandeling op de paden van het plateau',
    floraFaunaObservation: 'Observatie van lokale flora en fauna',
    mountainRhythmImmersion: 'Ondergedompeld worden in de langzame ritmes van de bergen',
    // Collalto Sabino specific activities
    ancientVillageWalk: 'Wandeling in het oude dorp',
    medievalStreetsExploration: 'Verkenning van middeleeuwse straatjes',
    panoramicPointsVisit: 'Bezoek aan panoramische punten',
    baronialCastleDiscovery: 'Ontdekking van het baronale kasteel',
    medievalHistoryImmersion: 'Ondergedompeld worden in de middeleeuwse geschiedenis',
    // Santo Stefano di Sessanio specific activities
    medievalVillageWalk: 'Wandeling in het middeleeuwse dorp',
    narrowStreetsExploration: 'Verkenning van smalle straatjes en pleinen',
    artisanShopsVisit: 'Bezoek aan ambachtelijke winkels',
    mediceanTowerClimb: 'Beklimming van de Medici Toren',
    silentBeautyImmersion: 'Ondergedompeld worden in stille schoonheid',
    // Villetta Barrea specific activities
    villettaBarreaHistoricCenterWalk: 'Wandeling in het historische centrum',
    sunsetDeerWatching: 'Begeleide zonsondergang excursie voor hert observatie',
    villettaBarreaPanoramicTrailsExploration: 'Verkenning van panoramische paden',
    villettaBarreaWildlifeObservation: 'Wildlife observatie',
    pristineNatureImmersion: 'Ondergedompeld worden in ongerepte natuur',
    // Pescocostanzo specific activities
    culturalHistoricCenterWalk: 'Culturele wandeling in het historische centrum',
    noblePalacesExploration: 'Verkenning van pleinen en adellijke paleizen',
    goldsmithTextileShopsVisit: 'Bezoek aan goudsmid- en textielwinkels',
    basilicaSantaMariaDiscovery: 'Ontdekking van de Basiliek van Santa Maria del Colle',
    refinedAtmosphereImmersion: 'Ondergedompeld worden in de verfijnde sfeer van het dorp',
    // Costa dei Trabocchi specific activities
    coastalPanoramicWalk: 'Panoramische wandeling langs de kust',
    historicTrabocchiVisit: 'Bezoek aan historische trabocchi',
    boatExcursionAlongCoast: 'Bootexcursie langs de kust',
    freshFishTasting: 'Verse vis proeverij',
    costaTrabocchiLandscapePhotography: 'Landschapsfotografie'
};

export default destinationDetails;

